var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAngeliaWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Calque_1",
    x: "0px",
    y: "0px",
    xmlSpace: "preserve",
    viewBox: "145.92 261.36 708.14 477.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st1{fill:#FFFFFF;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 538.67,
    cy: 359.41,
    r: 2.98
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 556.83,
    cy: 350.33,
    r: 3.41
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 575,
    cy: 341.25,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 575,
    cy: 359.41,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 593.16,
    cy: 332.17,
    r: 4.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 593.16,
    cy: 350.33,
    r: 4.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 611.32,
    cy: 323.09,
    r: 4.68
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 611.32,
    cy: 341.25,
    r: 4.68
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 611.32,
    cy: 359.41,
    r: 4.68
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 647.64,
    cy: 304.93,
    r: 5.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 647.64,
    cy: 323.09,
    r: 5.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 647.64,
    cy: 341.25,
    r: 5.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 647.64,
    cy: 359.41,
    r: 5.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 665.81,
    cy: 295.84,
    r: 5.96
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 665.81,
    cy: 314.01,
    r: 5.96
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 665.81,
    cy: 332.17,
    r: 5.96
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 665.81,
    cy: 350.33,
    r: 5.96
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 629.48,
    cy: 314.01,
    r: 5.11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 629.48,
    cy: 332.17,
    r: 5.11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 629.48,
    cy: 350.33,
    r: 5.11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 683.97,
    cy: 286.76,
    r: 6.39
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 683.97,
    cy: 304.93,
    r: 6.39
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 683.97,
    cy: 323.09,
    r: 6.39
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 683.97,
    cy: 341.25,
    r: 6.39
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 683.97,
    cy: 359.41,
    r: 6.39
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 702.13,
    cy: 277.68,
    r: 6.81
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 702.13,
    cy: 295.84,
    r: 6.81
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 702.13,
    cy: 314.01,
    r: 6.81
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 702.13,
    cy: 332.17,
    r: 6.81
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 702.13,
    cy: 350.33,
    r: 6.81
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 720.29,
    cy: 268.6,
    r: 7.24
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 720.29,
    cy: 286.76,
    r: 7.24
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 720.29,
    cy: 304.93,
    r: 7.24
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 720.29,
    cy: 323.09,
    r: 7.24
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 520.51,
    cy: 405.91,
    r: 2.55
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 520.51,
    cy: 424.07,
    r: 2.55
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 520.51,
    cy: 442.24,
    r: 2.55
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 520.51,
    cy: 460.4,
    r: 2.55
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 520.51,
    cy: 478.56,
    r: 2.55
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 538.67,
    cy: 378.67,
    r: 2.98
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 538.67,
    cy: 396.83,
    r: 2.98
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 538.67,
    cy: 414.99,
    r: 2.98
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 538.67,
    cy: 433.16,
    r: 2.98
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 538.67,
    cy: 451.32,
    r: 2.98
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 538.67,
    cy: 469.48,
    r: 2.98
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 556.83,
    cy: 387.75,
    r: 3.41
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 556.83,
    cy: 405.91,
    r: 3.41
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 556.83,
    cy: 424.07,
    r: 3.41
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 556.83,
    cy: 442.24,
    r: 3.41
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 556.83,
    cy: 460.4,
    r: 3.41
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 556.83,
    cy: 478.56,
    r: 3.41
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 556.83,
    cy: 369.59,
    r: 3.41
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 575,
    cy: 378.67,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 575,
    cy: 396.83,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 575,
    cy: 414.99,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 575,
    cy: 433.16,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 575,
    cy: 451.32,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 575,
    cy: 469.48,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 593.16,
    cy: 387.75,
    r: 4.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 593.16,
    cy: 405.91,
    r: 4.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 593.16,
    cy: 424.07,
    r: 4.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 593.16,
    cy: 442.24,
    r: 4.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 593.16,
    cy: 460.4,
    r: 4.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 593.16,
    cy: 369.59,
    r: 4.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 629.48,
    cy: 387.75,
    r: 5.11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 629.48,
    cy: 405.91,
    r: 5.11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 629.48,
    cy: 424.07,
    r: 5.11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 629.48,
    cy: 442.24,
    r: 5.11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 647.64,
    cy: 378.67,
    r: 5.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 647.64,
    cy: 396.83,
    r: 5.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 647.64,
    cy: 414.99,
    r: 5.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 647.64,
    cy: 433.16,
    r: 5.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 629.48,
    cy: 369.59,
    r: 5.11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 611.32,
    cy: 378.67,
    r: 4.68
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 611.32,
    cy: 396.83,
    r: 4.68
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 611.32,
    cy: 414.99,
    r: 4.68
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 611.32,
    cy: 433.16,
    r: 4.68
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 611.32,
    cy: 451.32,
    r: 4.68
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 665.81,
    cy: 387.75,
    r: 5.96
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 665.81,
    cy: 405.91,
    r: 5.96
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 665.81,
    cy: 424.07,
    r: 5.96
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 665.81,
    cy: 369.59,
    r: 5.96
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 683.97,
    cy: 378.67,
    r: 6.39
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 683.97,
    cy: 396.83,
    r: 6.39
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 702.13,
    cy: 369.59,
    r: 6.81
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 461.33,
    cy: 359.41,
    r: 2.98
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 443.17,
    cy: 350.33,
    r: 3.41
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 425,
    cy: 341.25,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 425,
    cy: 359.41,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 406.84,
    cy: 332.17,
    r: 4.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 406.84,
    cy: 350.33,
    r: 4.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 388.68,
    cy: 323.09,
    r: 4.68
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 388.68,
    cy: 341.25,
    r: 4.68
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 388.68,
    cy: 359.41,
    r: 4.68
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 352.36,
    cy: 304.93,
    r: 5.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 352.36,
    cy: 323.09,
    r: 5.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 352.36,
    cy: 341.25,
    r: 5.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 352.36,
    cy: 359.41,
    r: 5.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 334.19,
    cy: 295.84,
    r: 5.96
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 334.19,
    cy: 314.01,
    r: 5.96
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 334.19,
    cy: 332.17,
    r: 5.96
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 334.19,
    cy: 350.33,
    r: 5.96
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 370.52,
    cy: 314.01,
    r: 5.11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 370.52,
    cy: 332.17,
    r: 5.11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 370.52,
    cy: 350.33,
    r: 5.11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 316.03,
    cy: 286.76,
    r: 6.39
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 316.03,
    cy: 304.93,
    r: 6.39
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 316.03,
    cy: 323.09,
    r: 6.39
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 316.03,
    cy: 341.25,
    r: 6.39
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 316.03,
    cy: 359.41,
    r: 6.39
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 297.87,
    cy: 277.68,
    r: 6.81
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 297.87,
    cy: 295.84,
    r: 6.81
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 297.87,
    cy: 314.01,
    r: 6.81
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 297.87,
    cy: 332.17,
    r: 6.81
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 297.87,
    cy: 350.33,
    r: 6.81
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 279.71,
    cy: 268.6,
    r: 7.24
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 279.71,
    cy: 286.76,
    r: 7.24
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 279.71,
    cy: 304.93,
    r: 7.24
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 279.71,
    cy: 323.09,
    r: 7.24
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 479.49,
    cy: 405.91,
    r: 2.55
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 479.49,
    cy: 424.07,
    r: 2.55
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 479.49,
    cy: 442.24,
    r: 2.55
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 479.49,
    cy: 460.4,
    r: 2.55
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 479.49,
    cy: 478.56,
    r: 2.55
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 461.33,
    cy: 378.67,
    r: 2.98
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 461.33,
    cy: 396.83,
    r: 2.98
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 461.33,
    cy: 414.99,
    r: 2.98
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 461.33,
    cy: 433.16,
    r: 2.98
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 461.33,
    cy: 451.32,
    r: 2.98
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 461.33,
    cy: 469.48,
    r: 2.98
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 443.17,
    cy: 387.75,
    r: 3.41
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 443.17,
    cy: 405.91,
    r: 3.41
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 443.17,
    cy: 424.07,
    r: 3.41
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 443.17,
    cy: 442.24,
    r: 3.41
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 443.17,
    cy: 460.4,
    r: 3.41
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 443.17,
    cy: 478.56,
    r: 3.41
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 443.17,
    cy: 369.59,
    r: 3.41
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 425,
    cy: 378.67,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 425,
    cy: 396.83,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 425,
    cy: 414.99,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 425,
    cy: 433.16,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 425,
    cy: 451.32,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 425,
    cy: 469.48,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 406.84,
    cy: 387.75,
    r: 4.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 406.84,
    cy: 405.91,
    r: 4.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 406.84,
    cy: 424.07,
    r: 4.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 406.84,
    cy: 442.24,
    r: 4.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 406.84,
    cy: 460.4,
    r: 4.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 406.84,
    cy: 369.59,
    r: 4.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 370.52,
    cy: 387.75,
    r: 5.11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 370.52,
    cy: 405.91,
    r: 5.11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 370.52,
    cy: 424.07,
    r: 5.11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 370.52,
    cy: 442.24,
    r: 5.11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 352.36,
    cy: 378.67,
    r: 5.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 352.36,
    cy: 396.83,
    r: 5.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 352.36,
    cy: 414.99,
    r: 5.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 352.36,
    cy: 433.16,
    r: 5.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 370.52,
    cy: 369.59,
    r: 5.11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 388.68,
    cy: 378.67,
    r: 4.68
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 388.68,
    cy: 396.83,
    r: 4.68
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 388.68,
    cy: 414.99,
    r: 4.68
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 388.68,
    cy: 433.16,
    r: 4.68
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 388.68,
    cy: 451.32,
    r: 4.68
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 334.19,
    cy: 387.75,
    r: 5.96
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 334.19,
    cy: 405.91,
    r: 5.96
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 334.19,
    cy: 424.07,
    r: 5.96
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 334.19,
    cy: 369.59,
    r: 5.96
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 316.03,
    cy: 378.67,
    r: 6.39
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 316.03,
    cy: 396.83,
    r: 6.39
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 297.87,
    cy: 369.59,
    r: 6.81
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M218.03,619.5c6.91,0,12.74,0.59,17.48,1.78c4.74,1.19,8.53,3.04,11.37,5.57c2.84,2.53,4.87,5.78,6.11,9.75    c1.24,3.97,1.86,8.74,1.86,14.31v41.16c0,2.47-0.18,4.51-0.54,6.11c-0.36,1.6-0.98,2.86-1.86,3.79c-0.88,0.93-2.04,1.57-3.48,1.93    c-1.45,0.36-3.3,0.54-5.57,0.54h-73.65c-4.54,0-8.33-0.44-11.37-1.32c-3.04-0.88-5.49-2.19-7.35-3.95    c-1.86-1.75-3.17-4.02-3.95-6.81c-0.77-2.78-1.16-6.08-1.16-9.9v-7.43c0-3.2,0.39-6.06,1.16-8.59c0.77-2.53,2.09-4.67,3.95-6.42    c1.86-1.75,4.31-3.07,7.35-3.95c3.04-0.88,6.83-1.32,11.37-1.32h62.97v-2.94c0-2.48-0.26-4.59-0.77-6.34    c-0.52-1.75-1.39-3.17-2.63-4.25s-2.94-1.88-5.11-2.4c-2.17-0.52-4.95-0.77-8.35-0.77H151.2c-1.86,0-2.79-0.93-2.79-2.78v-13    c0-1.86,0.93-2.79,2.79-2.79H218.03z M228.25,687.42c1.65,0,2.81-0.39,3.48-1.16c0.67-0.77,1.01-2.14,1.01-4.1v-13.62h-56.63    c-3.2,0-5.44,0.65-6.73,1.93c-1.29,1.29-1.93,3.17-1.93,5.65v3.25c0,2.79,0.64,4.82,1.93,6.11c1.29,1.29,3.53,1.93,6.73,1.93    H228.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M352.17,619.5c6.91,0,12.74,0.59,17.48,1.78c4.74,1.19,8.53,3.04,11.37,5.57c2.84,2.53,4.87,5.78,6.11,9.75    c1.24,3.97,1.86,8.74,1.86,14.31v50.13c0,2.27-1.14,3.4-3.4,3.4h-15.16c-2.27,0-3.4-1.13-3.4-3.4v-44.87c0-3.2-0.21-5.9-0.62-8.12    c-0.41-2.22-1.21-3.97-2.4-5.26c-1.19-1.29-2.81-2.22-4.87-2.79c-2.06-0.57-4.75-0.85-8.05-0.85h-41.15c-3.3,0-6.03,0.29-8.2,0.85    c-2.17,0.57-3.89,1.5-5.18,2.79c-1.29,1.29-2.19,3.04-2.71,5.26c-0.52,2.22-0.77,4.93-0.77,8.12v44.87c0,2.27-1.14,3.4-3.4,3.4    H274.5c-2.37,0-3.56-1.13-3.56-3.4v-50.13c0-5.57,0.62-10.34,1.86-14.31c1.24-3.97,3.27-7.22,6.11-9.75    c2.84-2.53,6.6-4.38,11.29-5.57c4.69-1.18,10.54-1.78,17.56-1.78H352.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M486.93,619.5c7.01,0,12.87,0.59,17.56,1.78c4.69,1.19,8.48,3.02,11.37,5.49c2.89,2.48,4.92,5.7,6.11,9.67    c1.18,3.97,1.78,8.74,1.78,14.31v56.32c0,5.67-0.59,10.49-1.78,14.47c-1.19,3.97-3.23,7.22-6.11,9.75    c-2.89,2.53-6.68,4.38-11.37,5.57c-4.69,1.18-10.55,1.78-17.56,1.78h-72.87c-1.86,0-2.79-0.93-2.79-2.79v-13    c0-1.86,0.93-2.79,2.79-2.79h70.71c3.4,0,6.19-0.29,8.35-0.85c2.17-0.57,3.89-1.5,5.18-2.79c1.29-1.29,2.19-3.04,2.71-5.26    c0.52-2.22,0.77-4.98,0.77-8.28v-4.02h-58.17c-7.02,0-12.87-0.59-17.56-1.78c-4.69-1.18-8.46-3.04-11.29-5.57    c-2.84-2.53-4.87-5.78-6.11-9.75c-1.24-3.97-1.86-8.79-1.86-14.47v-16.25c0-5.67,0.62-10.49,1.86-14.47    c1.24-3.97,3.27-7.22,6.11-9.75c2.84-2.53,6.6-4.38,11.29-5.57c4.69-1.18,10.54-1.78,17.56-1.78H486.93z M428.91,667.16    c0,2.68,0.26,4.93,0.77,6.73c0.51,1.81,1.42,3.3,2.71,4.49c1.29,1.19,3.02,2.04,5.18,2.55c2.17,0.52,4.9,0.77,8.2,0.77h56.01    v-28.93c0-5.47-1.16-9.33-3.48-11.6c-2.32-2.27-6.83-3.4-13.54-3.4h-38.99c-3.3,0-6.03,0.26-8.2,0.77    c-2.17,0.52-3.89,1.37-5.18,2.55c-1.29,1.19-2.19,2.71-2.71,4.56c-0.52,1.86-0.77,4.08-0.77,6.65V667.16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M621.68,619.5c5.26,0,9.62,0.44,13.07,1.31c3.45,0.88,6.19,2.32,8.2,4.33c2.01,2.01,3.43,4.64,4.25,7.89    c0.82,3.25,1.24,7.19,1.24,11.84v14.7c0,3.3-0.72,5.6-2.17,6.88c-1.45,1.29-3.66,1.93-6.65,1.93H561.5v3.71    c0,4.85,1.16,8.35,3.48,10.52s6.83,3.25,13.54,3.25h64.52c1.86,0,2.78,0.93,2.78,2.79v13c0,1.86-0.93,2.79-2.78,2.79h-66.68    c-7.02,0-12.87-0.57-17.56-1.7c-4.69-1.13-8.46-2.96-11.29-5.49c-2.84-2.53-4.87-5.78-6.11-9.75c-1.24-3.97-1.86-8.74-1.86-14.31    v-22.28c0-5.57,0.62-10.34,1.86-14.31c1.24-3.97,3.27-7.22,6.11-9.75c2.84-2.53,6.6-4.38,11.29-5.57    c4.69-1.18,10.54-1.78,17.56-1.78H621.68z M561.5,654.62h62.66c1.75,0,2.63-0.88,2.63-2.63v-6.5c0-3.2-0.67-5.47-2.01-6.81    c-1.34-1.34-3.82-2.01-7.43-2.01h-38.83c-6.71,0-11.22,1.06-13.54,3.17c-2.32,2.12-3.48,5.65-3.48,10.6V654.62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M683.72,588.4c2.27,0,3.4,1.14,3.4,3.4v109.23c0,2.27-1.14,3.4-3.4,3.4h-15.16c-2.27,0-3.4-1.13-3.4-3.4    V591.81c0-2.27,1.13-3.4,3.4-3.4H683.72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M725.5,588.1c2.27,0,3.4,1.14,3.4,3.4v14.7c0,2.37-1.14,3.56-3.4,3.56h-15.16c-2.37,0-3.56-1.18-3.56-3.56    v-14.7c0-2.27,1.18-3.4,3.56-3.4H725.5z M725.5,619.5c2.27,0,3.4,1.19,3.4,3.56v77.98c0,2.27-1.14,3.4-3.4,3.4h-15.16    c-2.27,0-3.4-1.13-3.4-3.4v-77.98c0-2.37,1.13-3.56,3.4-3.56H725.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M817.24,619.5c6.91,0,12.74,0.59,17.48,1.78c4.74,1.19,8.53,3.04,11.37,5.57c2.84,2.53,4.87,5.78,6.11,9.75    c1.24,3.97,1.86,8.74,1.86,14.31v41.16c0,2.47-0.18,4.51-0.54,6.11c-0.36,1.6-0.98,2.86-1.86,3.79c-0.88,0.93-2.04,1.57-3.48,1.93    c-1.45,0.36-3.3,0.54-5.57,0.54h-73.65c-4.54,0-8.33-0.44-11.37-1.32c-3.04-0.88-5.49-2.19-7.35-3.95    c-1.86-1.75-3.17-4.02-3.95-6.81c-0.77-2.78-1.16-6.08-1.16-9.9v-7.43c0-3.2,0.39-6.06,1.16-8.59c0.77-2.53,2.09-4.67,3.95-6.42    c1.86-1.75,4.31-3.07,7.35-3.95c3.04-0.88,6.83-1.32,11.37-1.32h62.97v-2.94c0-2.48-0.26-4.59-0.77-6.34    c-0.52-1.75-1.39-3.17-2.63-4.25s-2.94-1.88-5.11-2.4c-2.17-0.52-4.95-0.77-8.35-0.77H750.4c-1.86,0-2.79-0.93-2.79-2.78v-13    c0-1.86,0.93-2.79,2.79-2.79H817.24z M827.45,687.42c1.65,0,2.81-0.39,3.48-1.16c0.67-0.77,1.01-2.14,1.01-4.1v-13.62h-56.63    c-3.2,0-5.44,0.65-6.73,1.93c-1.29,1.29-1.93,3.17-1.93,5.65v3.25c0,2.79,0.64,4.82,1.93,6.11c1.29,1.29,3.53,1.93,6.73,1.93    H827.45z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngeliaWhite);
export default __webpack_public_path__ + "static/media/angelia_white.dff45aae71714c18acf595b4f6b56eff.svg";
export { ForwardRef as ReactComponent };